import sound from "@assets/sounds/warningSound.mp3"
export function playWarningSound() {
    const audio = new Audio(sound);
    audio.play();
}